export default __webpack_public_path__ + "static/media/hero.a64eb4da.svg";